import styled from 'styled-components';

import {colors} from '@app/styles/theme';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const ControlsCard = styled.div`
    padding: 16px;
    background: ${colors.white};
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
`;

export const SearchBox = styled.div`
    width: 100%;
    max-width: 550px;
`;

export const ResultCell = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;
